/* Calm Supplements landing page (sections/calmy-lp-*.liquid).

   1. "Try Calmy Risk-Free" -> #calmy-offer. ONE delegated listener on the
      document, so it survives theme-editor section reloads without ever
      binding twice. Stays on this page (no navigation, URL untouched, so the
      draft-preview query string is kept). The destination is measured at the
      moment of the click: the real scroll container (desktop scrolls inside
      .page-wrapper, phones scroll the window) and the real bottom edge of the
      sticky header. A short smooth scroll (instant with reduced motion), then
      one correction pass in case the header changed height on the way.
      Never touches the cart.
   2. Review carousels: arrows and dots over a native scroll-snap track
      (swipe is native).
   3. Offer gallery when no product is connected (with a product,
      calmy-supp.js owns the gallery and the purchase form).
   4. Footer country selector submits on change. */
(function () {
  if (window.__calmyLp) return;
  window.__calmyLp = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scroller(el) {
    for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null; // the window
  }
  /* Bottom edge of whatever is pinned to the top of the screen (sticky or
     fixed header, sale bar), measured now. */
  function headerBottom() {
    var bottom = 0;
    var cands = document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group *, header, .chead');
    for (var i = 0; i < cands.length; i++) {
      var c = cands[i], cs = getComputedStyle(c);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      var r = c.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1 && r.bottom > bottom && r.bottom < window.innerHeight * 0.5) bottom = r.bottom;
    }
    return bottom;
  }
  var GAP = 12;
  function go(target) {
    var sc = scroller(target);
    function delta() { return target.getBoundingClientRect().top - (headerBottom() + GAP); }
    var behavior = reduce.matches ? 'instant' : 'smooth';
    var d = delta();
    /* 'instant', not 'auto': the theme sets scroll-behavior: smooth on the
       page, which would turn an 'auto' jump into a long animation.
       Keep the animation short: over long distances jump (instantly) to
       within ~60% of a screen of the offer, then glide the rest. */
    var lead = window.innerHeight * 0.6;
    if (behavior === 'smooth' && Math.abs(d) > lead * 2) {
      var jump = d - (d > 0 ? lead : -lead);
      if (sc) sc.scrollBy({ top: jump, behavior: 'instant' }); else window.scrollBy({ top: jump, behavior: 'instant' });
      d = delta();
    }
    if (sc) sc.scrollBy({ top: d, behavior: behavior }); else window.scrollBy({ top: d, behavior: behavior });
    /* Correction: the header can shrink/grow once it becomes "stuck". */
    var tries = 0;
    (function settle() {
      setTimeout(function () {
        var dd = delta();
        if (Math.abs(dd) > 3 && tries++ < 3) {
          if (sc) sc.scrollBy({ top: dd, behavior: 'instant' }); else window.scrollBy({ top: dd, behavior: 'instant' });
          settle();
        }
      }, behavior === 'smooth' ? 450 : 60);
    })();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#calmy-offer"]');
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var target = document.getElementById('calmy-offer');
    if (!target) return;
    e.preventDefault();
    go(target);
    /* Move focus to the offer for keyboard and screen-reader users without
       a second jump. */
    var price = target.nextElementSibling;
    if (price) { price.setAttribute('tabindex', '-1'); try { price.focus({ preventScroll: true }); } catch (err) {} }
  });

  /* ── Carousels ── */
  function initCarousel(root) {
    if (root.__lp) return;
    root.__lp = true;
    var track = root.querySelector('[data-lp-track]');
    var prev = root.querySelector('[data-lp-prev]'), next = root.querySelector('[data-lp-next]');
    var dotsBox = root.querySelector('[data-lp-dots]');
    if (!track) return;
    function cards() { return Array.prototype.slice.call(track.children); }
    function perView() {
      var c = cards()[0]; if (!c) return 1;
      return Math.max(1, Math.round(track.clientWidth / c.getBoundingClientRect().width));
    }
    function pages() { return Math.max(1, cards().length - perView() + 1); }
    function current() {
      var c = cards()[0]; if (!c) return 0;
      var step = c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return Math.round(track.scrollLeft / step);
    }
    function goTo(i) {
      var cs = cards(); i = Math.max(0, Math.min(pages() - 1, i));
      if (!cs[i]) return;
      track.scrollTo({ left: cs[i].offsetLeft - cs[0].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'lp-car__dot'; b.setAttribute('aria-label', 'Go to review ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { goTo(k); }); })(i);
        dotsBox.appendChild(b);
      }
      sync();
    }
    function sync() {
      var i = current(), n = pages();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
      if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    var lastW = 0;
    window.addEventListener('resize', function () { if (track.clientWidth !== lastW) { lastW = track.clientWidth; buildDots(); } });
    lastW = track.clientWidth; buildDots();
  }

  /* ── Offer gallery without a connected product ── */
  function initGallery(g) {
    if (g.__lp || g.closest('[data-csup-buy]')) return; // product galleries belong to calmy-supp.js
    g.__lp = true;
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-csup-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-csup-thumb]'));
    if (slides.length < 2) return;
    var cur = 0;
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); if (k === cur) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
      thumbs.forEach(function (t, k) { if (k === cur) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    var p = g.querySelector('[data-csup-prev]'), n = g.querySelector('[data-csup-next]');
    if (p) p.addEventListener('click', function () { show(cur - 1); });
    if (n) n.addEventListener('click', function () { show(cur + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var main = g.querySelector('[data-csup-main]'), x0 = null, y0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  /* ── Offer: shipping row (dispatch date) + low-stock notice ──
     Dispatch date: now + handling hours, moved forward to the next configured
     dispatch weekday, all in the store's timezone; formatted "Thu, Oct 8".
     Recomputed every minute (so it rolls over at midnight) and whenever the
     tab is shown again. The low-stock number comes only from Shopify's
     tracked inventory in the section's variant data; on returning to the tab
     after a while the section is re-fetched (Section Rendering API) so the
     number is fresh. Nothing here counts down or invents stock. */
  var DAY = 864e5;
  function tzParts(ms, tz) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short' });
    return { dow: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(f.format(new Date(ms))) };
  }
  function dispatchDate(nowMs, tz, hours, days) {
    var t = nowMs + hours * 36e5;
    if (days.length) { for (var i = 0; i < 8 && days.indexOf(tzParts(t, tz).dow) < 0; i++) t += DAY; }
    return new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(t));
  }
  window.__calmyLpDispatch = dispatchDate; // exposed for verification only

  /* THEME-EDITOR DEMO ONLY. Deterministic demo quantity from the wall clock in
     the given timezone (Intl handles daylight saving): max at fromH:00, falling
     linearly to min at toH:00, clamped outside that window. Only used when the
     card carries data-demo, which Liquid emits solely in request.design_mode. */
  function demoQty(ms, tz, fromH, toH, max, min) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(ms));
    var h = +parts.find(function (x) { return x.type === 'hour'; }).value, m = +parts.find(function (x) { return x.type === 'minute'; }).value;
    var t = h * 60 + m, a = fromH * 60, b = toH * 60;
    if (t <= a) return max;
    if (t >= b) return min;
    return Math.round(max - (max - min) * (t - a) / (b - a));
  }
  window.__calmyLpDemoQty = demoQty; // exposed for verification only

  function initOffer(sec) {
    if (sec.__lpShip) return;
    sec.__lpShip = true;
    var row = sec.querySelector('[data-lp-ship]'), warn = sec.querySelector('[data-lp-warn]');
    var data = [];
    function readData(root) { try { return JSON.parse(root.querySelector('[data-csup-variants]').textContent); } catch (e) { return null; } }
    data = readData(sec) || [];
    var idIn = sec.querySelector('[data-csup-id]');
    var cur = data.find(function (v) { return idIn && String(v.id) === idIn.value; }) || data[0] || null;
    var tz = row ? row.getAttribute('data-tz') || 'UTC' : 'UTC';
    try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); } catch (e) { tz = 'UTC'; }
    var hours = row ? parseFloat(row.getAttribute('data-hours')) || 0 : 0;
    var days = row ? row.getAttribute('data-days').split(',').filter(Boolean).map(Number) : [];
    function inStockNow(v) { return !!(v && v.available && (!v.tracked || v.qty > 0)); }
    function paint() {
      if (row) {
        var l = row.querySelector('.lp-shiprow__l'), st = row.querySelector('[data-lp-ship-status]');
        var when = row.querySelector('[data-lp-ship-when]'), date = row.querySelector('[data-lp-ship-date]');
        var ok = inStockNow(cur);
        st.textContent = ok ? row.getAttribute('data-ready') : (cur && cur.available ? row.getAttribute('data-backorder') : row.getAttribute('data-soldout'));
        l.classList.toggle('is-off', !ok); l.classList.toggle('is-out', !(cur && cur.available));
        if (ok) { date.textContent = dispatchDate(Date.now(), tz, hours, days); when.hidden = false; } else { when.hidden = true; }
      }
      if (warn) {
        /* Real warning only for tracked, available stock of 1..threshold.
           A theme-editor design preview (data-preview) stays visible with its
           sample number; the customer-facing card is never invented. */
        var th = parseFloat(warn.getAttribute('data-threshold')) || 0;
        var real = !!(cur && cur.tracked && cur.available && cur.qty > 0 && cur.qty <= th);
        var prev = warn.hasAttribute('data-preview');
        if (prev && warn.hasAttribute('data-demo')) {
          var dq = demoQty(Date.now(), warn.getAttribute('data-demo'), +warn.getAttribute('data-demo-from'), +warn.getAttribute('data-demo-to'), +warn.getAttribute('data-demo-max'), +warn.getAttribute('data-demo-min'));
          warn.hidden = false;
          Array.prototype.forEach.call(warn.querySelectorAll('[data-lp-qty]'), function (n) { n.textContent = dq; });
          var dqw = warn.querySelector('[data-lp-warn-q]'); if (dqw) dqw.hidden = warn.getAttribute('data-show-qty') !== 'true';
        } else if (real) {
          warn.hidden = false;
          Array.prototype.forEach.call(warn.querySelectorAll('[data-lp-qty]'), function (n) { n.textContent = cur.qty; });
          var qw = warn.querySelector('[data-lp-warn-q]'); if (qw) qw.hidden = warn.getAttribute('data-show-qty') !== 'true';
        } else if (!prev) {
          warn.hidden = true;
        }
      }
    }
    sec.addEventListener('csup:variant', function (e) {
      var v = e.detail && e.detail.variant;
      cur = v ? (data.find(function (x) { return x.id === v.id; }) || v) : null;
      paint();
    });
    var hiddenAt = 0;
    function refreshStock() {
      var id = sec.getAttribute('data-section-id'); if (!id) return;
      var u = new URL(location.href); u.searchParams.set('sections', id);
      fetch(u.toString(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j[id]) return;
          var doc = new DOMParser().parseFromString(j[id], 'text/html');
          var fresh = readData(doc); if (!fresh) return;
          data = fresh;
          if (cur) cur = data.find(function (x) { return x.id === cur.id; }) || cur;
          paint();
        }).catch(function () {});
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { hiddenAt = Date.now(); return; }
      paint();
      if (hiddenAt && Date.now() - hiddenAt > 60000) refreshStock();
    });
    (function tick() { setTimeout(function () { paint(); tick(); }, 60000 - (Date.now() % 60000) + 50); })();
    paint();
  }

  function scan(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-lp-car]'), initCarousel);
    Array.prototype.forEach.call(root.querySelectorAll('[data-lp-gal]'), initGallery);
    Array.prototype.forEach.call(root.querySelectorAll('[data-lp-offer]'), initOffer);
    Array.prototype.forEach.call(root.querySelectorAll('form[data-lp-loc]'), function (f) {
      if (f.__lp) return; f.__lp = true;
      var s = f.querySelector('select'); if (s) s.addEventListener('change', function () { f.submit(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
